'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useContext } from 'react'

// lib
import { accessibilityLabel } from '@components/kit/_support'
import Box from '@components/kit/box'
import Pressable from '@components/kit/pressable'
import SymptomLogHistoryContext from './symptom-log-history-context'
import Text from '@components/kit/text'
import { BackIcon } from '@components/kit/icons'
import { contentMaxWidth } from '@components/kit/page'

/* -----------------------------------------------------------------------------
 * SymptomLogHistoryHeader
 * -------------------------------------------------------------------------- */

export const DEFAULT_HEADER_HEIGHT = 140

type SymptomLogHistoryHeaderProps = {
  goBack?: () => void
}

const SymptomLogHistoryHeader = ({ goBack }: SymptomLogHistoryHeaderProps) => {
  const { headerState, headerHeight } = useContext(SymptomLogHistoryContext)

  return (
    <Box
      flexDirection='column'
      position='absolute'
      top={0}
      height={headerHeight}
      width='100%'
      maxWidth={contentMaxWidth}
      borderColor='shade02'
      borderBottomWidth={headerState ? 1 : 0}
      bg='white'
      pt={goBack ? '48' : '16'}
      pb='16'
      zIndex={1}
      {...accessibilityLabel('Symptom Log History Header')}
    >
      {goBack && (
        <Pressable pb='20' pl='16' onPress={goBack}>
          <BackIcon fill='violet' />
        </Pressable>
      )}
      {headerState && (
        <Box
          flexDirection='row'
          justifyContent='space-between'
          alignItems='flex-end'
          px='24'
        >
          <Text
            variant='h2'
            {...accessibilityLabel('Symptom Log History Header Month')}
          >
            {headerState.date.format('MMMM YYYY')}
          </Text>
          <Text
            variant='small'
            textColor='violet'
            {...accessibilityLabel('Symptom Log History Header Total')}
          >
            {headerState.logCount}
            {headerState.logCount === 1 ? ' log' : ' logs'}
          </Text>
        </Box>
      )}
    </Box>
  )
}

export default SymptomLogHistoryHeader
